export default __webpack_public_path__ + "static/media/icon6.5bf48a0c.svg";